import React, { memo } from 'react'

import { Avatar, makeStyles } from '@material-ui/core'

import ImagePlaceholder from './ImagePlaceholder'
import SearchAnyProductIcon from '~/components/SearchAnyProductIcon'
import { mountUrl, replaceImagePath } from '~/utils'

const useStyles = makeStyles((theme) => ({
  avatar: {
    background: '#FFF',
    '&.bg': {
      background: theme.palette.secondary.main
    }
  }
}))

function ProductImageThumb({ product }) {
  const classes = useStyles()

  const image = replaceImagePath(product)

  if (!image) {
    return (
      <Avatar>
        <SearchAnyProductIcon />
      </Avatar>
    )
  }

  return (
    <ImagePlaceholder
      src={mountUrl(image, { height: 100 })}
      placeholder={mountUrl(image, { height: 100 })}
    >
      {(src, loading) =>
        loading ? (
          <Avatar className={classes.avatar}>
            <SearchAnyProductIcon />
          </Avatar>
        ) : (
          <Avatar className={classes.avatar} src={src} alt={product.name} />
        )
      }
    </ImagePlaceholder>
  )
}

export default memo(ProductImageThumb)
